import {Action} from '@ngrx/store';
import {Ota} from '@app/core/models/ota.model';
import {ICombineEngine} from '@app/shared/interfaces/icombine-engine.interface';

export enum OtaActionType {
    AddNew = '[OTA] add.new',
    AddCombine = '[OTA] add.combine'
}

export class OtaAddNew implements Action {
//    type: string = '[OTA] add.new';
        type: string = OtaActionType.AddNew;

    constructor(public payload: Ota) {}
}

export class OtaAddCombine implements Action {
//    type: string = '[OTA] add.combine';
        type: string = OtaActionType.AddCombine;

    constructor(public payload: ICombineEngine) {}
}